import React, { useState } from 'react'
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip } from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import WarningIcon from '@material-ui/icons/Warning'
import { HOURS_TERMS, liveValue, ASPIRE_INFLATED_WARNING } from './hoursGlossary'

function GlossaryRow({ term, property }) {
  const v = liveValue(term.key, property)
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '160px 80px 1fr', gap: 8, padding: '8px 0', alignItems: 'baseline' }}>
      <div>
        <span style={{ fontWeight: 500 }}>{term.label}</span>{' '}
        <span style={{ fontSize: 11 }}>{term.unit}</span>
      </div>
      <div style={{ fontFamily: 'monospace' }}>{typeof v === 'number' ? `${Math.round(v * 100) / 100}h` : '—'}</div>
      <div style={{ fontSize: 12 }}>
        {term.definition}
        {term.caveat === 'aspire-inflated' && (
          <Tooltip title={ASPIRE_INFLATED_WARNING}>
            <WarningIcon aria-label="unreliable" fontSize="small" color="error" style={{ verticalAlign: 'middle', marginLeft: 4 }} />
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export function HoursGlossaryButton({ property }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <IconButton aria-label="Hours glossary" size="small" onClick={() => setOpen(true)}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Hours glossary</DialogTitle>
        <DialogContent>
          {Object.values(HOURS_TERMS).map((t) => (
            <GlossaryRow key={t.key} term={t} property={property} />
          ))}
        </DialogContent>
        <DialogActions><Button onClick={() => setOpen(false)}>Close</Button></DialogActions>
      </Dialog>
    </>
  )
}
